module.exports = __webpack_public_path__ + "static/Veneers 1 intraoral before-3bdb3ccb722eb8b405decb67029c9320.jpg";